import React, { useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { switchRoleApi } from "../../../service/api/user/switchRole";
import { setUserDetails } from "../../../feature/userData/userData";
import ResponceToaster from "../responceToaster/responceToaster";
import { useNavigate } from 'react-router-dom';
import InputField from "../fields/inputField";
import PrimaryButton from "../button/primaryButton";
import { addRoleByAdminApi } from "../../../service/api/user/addRoleByAdmin";


const AddRoleModal= ({onClose,modalStatus}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
 const[roleName,setRoleName] = useState("")
 const[roleDescription,setRoleDEscription] = useState("")
 const[errorRoleName,setErrorRoleName] = useState(false)
 const[errorRoleDescription,setErrorRoleDescription] = useState(false)
 const[isSavingRole,setIsSavingRole] = useState(false)
  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState();
  const [handleToaster, setHandleToaster] = useState(false);


  const handleSubmit = (e) => {
    e.preventDefault();
  
  };


 function handleRoleDescription(e){
    setRoleDEscription(e.target.value)
    setErrorRoleDescription(false)
 }
 function handleRoleName(e){
    setRoleName(e.target.value)
    setErrorRoleName(false)
 }
 function saveNewRole(){
if(roleName.length > 2){

    let details = new FormData();
    details.append("role_name_chr",roleName)
    details.append("role_description_chr",roleDescription)
    
     dispatch(addRoleByAdminApi(details,(res)=>{
        setResponceMsg(res.data.message);
        setToasterType("success");
        setHandleToaster(true);
       onClose()
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
     },(err)=>{
        setResponceMsg(err.data.message);
      setToasterType("error");
      setHandleToaster(true);
    
      setTimeout(() => {
        setHandleToaster(false);
      }, 11000);
     }))
}else{
    setErrorRoleName(true)
}
}
  return (
    <>
      {/* <!-- Modal --> */}
      <Modal
        className="fade"
        show={modalStatus}
      // onHide={handleCloseChangePassword}
      >
        <Modal.Header style={{ borderBottom: "none" }}>
          <Modal.Title>{"Add New Role"}</Modal.Title>
         
          <Button
            variant=""
            className="btn-close btn-close-password"
            onClick={onClose}
            ></Button>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => handleSubmit(e)}>
          <InputField
                                        labelName={"Role Name"}
                                        placeholderName={"Enter role name"}
                                        value={roleName}
                                        onChange={handleRoleName}
                                        errorOccured={errorRoleName}
                                        errorMeesage={"Please enter valid role name "}
                                        onBlur={() => {}}
                                    />
                                     <InputField
                                        labelName={"Role Description"}
                                        placeholderName={"Enter role description"}
                                        value={roleDescription}
                                        onChange={handleRoleDescription}
                                        errorOccured={errorRoleDescription}
                                        errorMeesage={"Please enter valid role description "}
                                        onBlur={() => {}}
                                    />
                                    <div className="mb-4"></div>
                                    <PrimaryButton buttonName={"Add"} onClick={saveNewRole} isLoading={isSavingRole} loadingMessage={"Adding"}/>
         
          </form>
        </Modal.Body>
      </Modal>

      {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

    </>
  );
};

export default AddRoleModal;